import cassetteImg from "../assets/cassette.png";

export default function Cassette() {
  return (
    <div className="cassette-wrapper">
      <img
        src={cassetteImg}
        alt="cassette tape"
        className="cassette-img"
      />
    </div>
  );
}
